import styles from "../../style.module.scss";
import useStore from "../../store/store";
import {useState} from "react";
import formatPrice from "../../utils/format-price";
import {serviceType} from "../../utils/service-type";
import Hint from "../ui/hint/hint";
import {getServiceDescription, getServiceName} from "../../utils/service-text";

function Step6({number, services}) {
    const [open, setOpen] = useState(false);
    const ratesHide = useStore((state) => state.ratesHide)
    const carServices = useStore((state) => state.carServices)
    const isCheckedCarService = useStore((state) => state.isCheckedCarService)
    const checkCarService = useStore((state) => state.checkCarService)
    const unCheckCarService = useStore((state) => state.unCheckCarService)
    const lang = useStore((state) => state.lang)

    const t = {
        additionalServices: lang === 'en' ? 'Additional services' : 'Дополнительные услуги',
        notSelected: lang === 'en' ? 'Not selected' : 'Не выбрано',
        perDay: lang === 'en' ? ' / day' : ' / cут.'
    };

    const getCurrentValue = () => {
        if (!!carServices.length) {
            return carServices.map((item, index) => `${index > 0 ? ', ' : ''}${item.name}`)
        }
        return t.notSelected;
    }
    const handleCheckboxClick = (serviceId, name) => {
        if (isCheckedCarService(serviceId)) {
            unCheckCarService(serviceId);
        } else {
            checkCarService(serviceId, name);
        }
    }

    if (!services) {
        return null;
    }

    return (<div className={styles.newOrder__step}>
        <div className={`${styles.newOrder__stepHead} p-size`} onClick={() => setOpen(!open)}>
            <div className={styles.newOrder__stepNumber}>
                {ratesHide ? number - 1 : number}
            </div>
            {t.additionalServices}
            <div className={styles.newOrder__stepValue}>{getCurrentValue()}</div>
            <div className={`${styles.newOrder__stepStatus} ${open && styles.open}`}/>
        </div>
        {
            open && (
                <div className={styles.newOrder__stepContent}>
                    <div className={styles.locations}>
                        {
                            services.map((item) => {

                                if (item.caraddonsitegroup === 'Дополнительные услуги' && !!item.caraddonsitename) {
                                    const price = parseInt(item.caraddonprice);
                                    const name = getServiceName(item, lang);
                                    const serviceDescription = getServiceDescription(item, lang);
                                    return (
                                        <div key={item.caraddonid} className={styles.location}
                                             onClick={() => handleCheckboxClick(item.caraddonid, name)}>
                                            <div
                                                className={`${styles.multiCheckbox} ${isCheckedCarService(item.caraddonid) && styles.checked}`}/>
                                            <span className={`${styles.heading} p-small-size`}>
                                            {name}
                                                {!!price && serviceType(item.caraddontype) === 'one_time' && (` (+${formatPrice(price)})`)}
                                                {!!price && serviceType(item.caraddontype) === 'day' && (` (+${formatPrice(price, t.perDay)})`)}
                                                {
                                                    !!serviceDescription && (
                                                        <Hint text={serviceDescription}/>)
                                                }
                                        </span>
                                        </div>
                                    )
                                }
                                return null;
                            })
                        }
                    </div>
                </div>
            )
        }

    </div>);
}

export default Step6;